
(function () {
  /* ---------- CONFIG ------------------------------------------------- */
  const PHP_ENDPOINT      = 'https://shopify.api.nomilk.dev/einrum/locations-data.php';
  const ICELAND_COUNTRY   = 'IS';
  const ICELAND_WAREHOUSE = 'IS';
  const DK_WAREHOUSE      = 'DK';
  const CACHE_TTL         = 30_000;                         // ms
  const ERROR_TXT         = 'Not in stock in your region';

  /* ---------- STATE -------------------------------------------------- */
  const stockCache = new Map();                             // variantId → {IS, DK, ts}
  let   visitorCountry = detectCountry();
  console.log('[STOCK] visitorCountry =', visitorCountry);

  /* ---------- INIT --------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const variantEls = [...document.querySelectorAll('.list-variant[data-id]')];
    const variantIds = variantEls.map(el => +el.dataset.id);
    if (!variantEls.length) return;

    decorateVariantRows(variantEls);          // initial placeholder
    fetchStock(variantIds).then(() => {
      updateRows(variantEls);
      hookQuantityControls(variantEls);       // keep the UI consistent when user clicks +/- after first update
    });
  }

  /* ---------- COUNTRY DETECTION ------------------------------------- */
  function detectCountry () {
    const cookie = document.cookie.split('; ')
      .find(c => c.startsWith('_shopify_country='));
    if (cookie)            return cookie.split('=')[1].toUpperCase();
    if (window.Shopify?.country)  return Shopify.country;
    if (window.Shopify?.locale)   return Shopify.locale.split('-').pop().toUpperCase();
    return DK_WAREHOUSE;   // fallback
  }

  /* ---------- STOCK FETCH ------------------------------------------- */
  async function fetchStock (variantIds = []) {
    const idsToFetch = variantIds.filter(id => {
      const rec = stockCache.get(id);
      const stale = !rec || Date.now() - rec.ts > CACHE_TTL;
      console.log(`[STOCK] cache ${stale ? 'MISS' : 'HIT'} → ${id}`);
      return stale;
    });
    if (!idsToFetch.length) return;

    console.log('[STOCK] fetching', idsToFetch);
    const res  = await fetch(PHP_ENDPOINT, {
      method : 'POST',
      headers: {'Content-Type':'application/json'},
      body   : JSON.stringify({ variantIds: idsToFetch })
    });
    if (!res.ok) { console.warn('[STOCK] fetch failed'); return; }
    const data = await res.json();
    Object.entries(data).forEach(([id, payload]) =>
      stockCache.set(+id, {...payload, ts: Date.now()})
    );
    console.log('[STOCK] payload', data);
  }

  /* ---------- UTIL --------------------------------------------------- */
  function freeUnits (variantId) {
    const rec = stockCache.get(variantId);
    if (!rec) return Infinity;                                   // optimistic while waiting
    return visitorCountry === ICELAND_COUNTRY
      ? rec[ICELAND_WAREHOUSE] ?? 0
      : rec[DK_WAREHOUSE]      ?? 0;
  }

  function allowedToBuy (variantId, qtyNeeded = 1) {
    return freeUnits(variantId) >= qtyNeeded;
  }

  /* ---------- RENDER ------------------------------------------------- */
  function decorateVariantRows (variantEls) {
    variantEls.forEach(el => {
      const dkSpan = el.querySelector('.stock-level[data-location="dk"]');
      const isSpan = el.querySelector('.stock-level[data-location="is"]');
      if (dkSpan) {
        dkSpan.textContent = '—';
        dkSpan.classList.add('waiting');
      }
      if(isSpan){
        isSpan.textContent = '—';
        isSpan.classList.add('waiting');
      }
    });
  }

    function enforceLimit (id, input) {
        const cap = freeUnits(id);
        const val = +input.value || 0;

        if (val > cap) {
          const rounded = cap > 9               // handle single-digit caps gracefully
            ? Math.floor(cap / 10) * 10         // 37 → 30, 120 → 120
            : cap;                              // cap ≤ 9  → keep the exact cap

          alert(`${ERROR_TXT}. Max ${rounded} available in your region.`);
          input.value = rounded;
          input.dispatchEvent(new Event('updateError', { bubbles: true }));
        }
    }

  function updateRows (variantEls) {
    variantEls.forEach(el => {
        const id       = +el.dataset.id;
        const dkSpan   = el.querySelector('.stock-level[data-location="dk"]');
        const isSpan   = el.querySelector('.stock-level[data-location="is"]');
        const qtyInput = el.querySelector('.quantity-input');
        const plusBtn  = el.querySelector('[data-action="increment"]');
        const minusBtn = el.querySelector('[data-action="decrement"]');

        const rec = stockCache.get(id);
        const dkStock = rec?.[DK_WAREHOUSE] ?? 0;
        const isStock = rec?.[ICELAND_WAREHOUSE] ?? 0;
        
        
       
        if (dkSpan) {
            dkSpan.classList.remove('waiting');
            dkSpan.textContent = `Stock DK:${dkStock}`;

        }
        if (isSpan) {
            isSpan.classList.remove('waiting');
            isSpan.textContent = `Stock IS: ${isStock}`;    
        }

        const canBuy = allowedToBuy(id);
        qtyInput.disabled = !canBuy;
        plusBtn.disabled  = !canBuy;
        minusBtn.disabled = !canBuy;

        if (!canBuy) {
            el.classList.add('out-of-stock');
            qtyInput.value = 0;
            qtyInput.setAttribute('placeholder', ERROR_TXT);
        } else {
            el.classList.remove('out-of-stock');
            qtyInput.max = freeUnits(id);
        }
    });
  }

  /* ---------- QUANTITY VALIDATION ----------------------------------- */
  function hookQuantityControls (variantEls) {
  variantEls.forEach(el => {
    const id       = +el.dataset.id;
    const input    = el.querySelector('.quantity-input');
    const plusBtn  = el.querySelector('[data-action="increment"]');
    const minusBtn = el.querySelector('[data-action="decrement"]');
    if (!input) return;

    /* text entry, up-/down arrows, copy-paste… */
    input.addEventListener('input', () => enforceLimit(id, input));
    /* blur fallback for browsers that suppress real-time input */
    input.addEventListener('change', () => enforceLimit(id, input));

    /* clicks on the ± buttons */
    [plusBtn, minusBtn].forEach(btn => {
      btn?.addEventListener('click', () => {
        // buttons fire before the DOM updates → wait one tick
        setTimeout(() => enforceLimit(id, input));
      });
    });
  });
}

/* ------------------------------------------------------------------ */
/* 1. HOOK WHEN THE CART DRAWER OPENS OR RE-RENDERS                   */
/* ------------------------------------------------------------------ */
// Dawn & most modern themes fire "cart:updated" after any cart AJAX.
// Fall back to DOMContentLoaded (page-load cart view).
['cart:updated', 'DOMContentLoaded'].forEach(evt =>
  document.addEventListener(evt, initCart)
);

/* ------------------------------------------------------------------ */
/* 2. SCAN CART ITEMS, FETCH STOCK, WIRE LISTENERS                    */
/* ------------------------------------------------------------------ */
function initCart () {
  const cartEls = [...document.querySelectorAll('.cart-item[data-variant-id]')];
  if (!cartEls.length) return;

  const ids = cartEls.map(el => +el.dataset.variantId);
  fetchStock(ids).then(() => {
    updateCartRows(cartEls);
    hookCartQuantityControls(cartEls);
  });
}

/* ------------------------------------------------------------------ */
/* 3. UPDATE THE ± BUTTONS + INPUT STATES                             */
/* ------------------------------------------------------------------ */
function updateCartRows (cartEls) {
  cartEls.forEach(el => {
    const id       = +el.dataset.variantId;
    const input    = el.querySelector('.quantity__input');
    const plusBtn  = el.querySelector('[name="plus"]');
    const minusBtn = el.querySelector('[name="minus"]');

    const cap   = freeUnits(id);
    const value = +input.value || 0;

    // visual lock if nothing left in warehouse
    const disabled = cap === 0;
    [input, plusBtn, minusBtn].forEach(node => node.disabled = disabled);

    // make sure value never exceeds cap (important on page load refresh)
    if (value > cap) input.value = cap;
  });
}

/* ------------------------------------------------------------------ */
/* 4. RE-USE THE SAME LIMIT-ENFORCEMENT LOGIC IN THE CART             */
/* ------------------------------------------------------------------ */
function hookCartQuantityControls (cartEls) {
  cartEls.forEach(el => {
    const id       = +el.dataset.variantId;
    const input    = el.querySelector('.quantity__input');
    const plusBtn  = el.querySelector('[name="plus"]');
    const minusBtn = el.querySelector('[name="minus"]');
    if (!input) return;

    // typing, wheel, manual changes
    ['input', 'change'].forEach(evt =>
      input.addEventListener(evt, () => enforceLimit(id, input))
    );

    // clicks on ± buttons: wait a tick because Shopify changes the DOM after click
    [plusBtn, minusBtn].forEach(btn =>
      btn?.addEventListener('click', () =>
        setTimeout(() => enforceLimit(id, input))
      )
    );
  });
}




})();
